var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckCircleIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.99902C2.2385 9.99902 0 7.76052 0 4.99902C0 2.23752 2.2385 -0.000976562 5 -0.000976562C7.7615 -0.000976562 10 2.23752 10 4.99902C10 7.76052 7.7615 9.99902 5 9.99902ZM4.14792 6.64544C4.34319 6.84072 4.6598 6.84071 4.85505 6.64542L7.68305 3.81702C7.87826 3.62178 7.87825 3.30527 7.68303 3.11005C7.48779 2.91481 7.17123 2.91482 6.976 3.11008L4.5015 5.58502L3.4405 4.52402C3.24527 4.32879 2.92873 4.32879 2.7335 4.52402C2.53827 4.71926 2.53827 5.03579 2.7335 5.23102L4.14792 6.64544Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckCircleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckCircleIcon.0dcdf3b2.svg";
export { ForwardRef as ReactComponent };